/* ════════════════════════════════════════════════════════════════
   retard-motion.js — WS5 restrained brand motion.
   Lenis weighted smooth-scroll + staggered rise-in reveals + a
   choreographed hero entrance. Defensive: classes are added by JS, so
   no-JS visitors never get hidden content; reduced-motion = static; and
   a hard safety timer force-reveals anything the observer missed.
   ════════════════════════════════════════════════════════════════ */
(function () {
  var body = document.body;
  if (!body || body.className.indexOf('retard-mode') === -1) return;

  var reduce = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── 1. Lenis smooth-scroll (real-scroll mode → position:sticky safe) ── */
  if (!reduce && typeof window.Lenis === 'function') {
    try {
      var lenis = new window.Lenis({
        duration: 1.05,
        easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
        smoothWheel: true
      });
      var raf = function (time) { lenis.raf(time); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    } catch (e) { /* scroll stays native — never block the page on motion */ }
  }

  if (reduce) return; /* no reveals / no choreography for reduced-motion */

  /* ── 2. Hero load choreography — stagger the above-the-fold bits in ── */
  var heroSel = ['.retard-masthead', '.retard-header-bar--thin', '.retard-marq',
                 '.retard-search', '.retard-buy'];
  var heroEls = [];
  heroSel.forEach(function (s) {
    var el = document.querySelector(s);
    if (el) heroEls.push(el);
  });
  heroEls.forEach(function (el, i) {
    el.style.setProperty('--rg-d', (i * 0.07) + 's');
    el.classList.add('rg-load');
  });

  /* ── 3. Scroll reveals on the below-the-fold slabs ── */
  var revealSel = '.retard-product-grid, .retard-bundle, .retard-card, ' +
                  '.rg-memberband, .rg-breath, .map-ad, [class*="map-ad"]';
  var slabs = [].slice.call(document.querySelectorAll(revealSel))
    .filter(function (el) { return !el.closest('.retard-buy'); });

  if (!slabs.length) return;

  if (!('IntersectionObserver' in window)) {
    slabs.forEach(function (el) { el.classList.add('rg-in'); });
    return;
  }

  slabs.forEach(function (el, i) {
    el.classList.add('rg-reveal');
    /* small per-item stagger so neighbours don't pop in lockstep */
    el.style.setProperty('--rg-d', ((i % 3) * 0.05) + 's');
  });

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) {
        e.target.classList.add('rg-in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.04 });

  slabs.forEach(function (el) { io.observe(el); });

  /* ── 4. Safety net: never leave a slab invisible (observer edge cases) ── */
  setTimeout(function () {
    slabs.forEach(function (el) {
      if (!el.classList.contains('rg-in')) el.classList.add('rg-in');
    });
  }, 2600);
})();
